import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { BnNgIdleService } from 'bn-ng-idle';

import { filter } from 'rxjs';
import { FlagImgConstants } from 'src/app/models/flag_img';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-prenavbar',
  templateUrl: './prenavbar.component.html',
  styleUrls: ['./prenavbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrenavbarComponent implements OnInit {
  title = 'Global Admin';
  public interval :any;
  loggedIn = false;
  displayBasic: boolean=false;
  counter=0;
  country : String;
  subscription: any;
  showDropdown = false;
  selected:String;
  selectedCountryCode="default";
  errorMsg:String;
  show:String;
  userPrimaryAccess:any = "";
  countrySelected: string ;
  countryMap = new Map();
  selectedCountry: any;
  superAdminDashboradAccessList = [];
  displayDialog: boolean;
  flagLocation: any;
  countryName: any;
  constructor(
    private router: Router,
    private storageService: StorageService,
    private bnIdle: BnNgIdleService,
    private encryptDecryptService: EncryptDecryptService,
    private sharedService: SharedService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    }

  ngOnInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      ).subscribe((result: EventMessage) => {
        console.log(result);
      });

    this.storageService.encodeValue("X-TENANT-ID", "NA");
    this.storageService.encodeValue("Country", "NA");
    this.encryptDecryptService.resetPassPhrase();
   }   
  showHide($event) {

      if(this.selectedCountryCode=='default'){
        this.show= "please select a country"
      }
      else {
          this.show=""
      }
  }
  redirectDashboard() {

    if (this.selectedCountryCode != "default") {
      this.configureAndRedirectToHome();
    } else {
      this.errorMsg = "Please select a country";
    }
  }

  configureAndRedirectToHome() {
    this.storageService.encodeValue("Country", this.selectedCountryCode);
      this.storageService.encodeValue("CountryName", this.selectedCountry);
      this.sharedService.setcountryCode(this.selectedCountryCode);
      this.sharedService.setcountryName(this.selectedCountry);
      this.sharedService.emitCountryCodeChange();
      this.sharedService.emitCountryNameChange();
      if (this.selectedCountryCode != 'GBL') {
        if (this.selectedCountry === 'Kingdom of Saudi Arabia') {
          this.flagLocation = FlagImgConstants.FlagImageMap['KSA'];
        } else {
          this.flagLocation = FlagImgConstants.FlagImageMap[this.selectedCountry.toUpperCase()];

        }
        this.storageService.encodeValue("CountryFlagLocation", this.flagLocation);
        this.sharedService.setCountryFlagLocation(this.flagLocation);
        this.sharedService.emitCountryFlagLocationChange();

      }
      if (this.selectedCountryCode === 'GBL') {
        this.storageService.encodeValue("Country", this.selectedCountryCode);
        this.router.navigate(['home/superadmin']);
      }
      else if (this.selectedCountryCode === 'KSA') {
        this.storageService.encodeValue("Country", this.selectedCountryCode);
        this.router.navigate(['home/ksa']);
      } else if (this.selectedCountryCode === 'MIS') {
        this.router.navigate(['home/mis-dashboard']);
      } else {
        this.router.navigate(['home/dashboard']);
      }
  }

  logout() {
    this.storageService.logOut(false);
  }

  startCountdown(seconds: number ){
      this.interval = setInterval(() => {
          if (seconds == 0) {
              this.displayBasic = false;
              clearInterval(this.interval);
              this.storageService.unAuthUserFound();
          }
          this.counter=seconds--;
          }, 1000);
       }


    continue(){
      this.displayBasic = false;
      clearInterval(this.interval);
    }
    cancel(){
      this.storageService.unAuthUserFound();
    }

country1(code) {
  this.selectedCountryCode = code.target.value;
  this.selectedCountry=code.target[code.target.selectedIndex].text;
  this.errorMsg = "";
}
  fa(fa: any) {
    throw new Error('Method not implemented.');
  }

CheckIdelUsers(){
      this.bnIdle.startWatching(60).subscribe((isTimedOut: boolean) => {
          if (isTimedOut) {
            this.displayBasic = true;
            this.startCountdown(60)
          }
        });
    }
}
function Intials(cString: string) {
  return cString
      ?.split(' ')
      .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
      .join('');
}
interface Role {
  id: number;
  name: string;
}
